import React, { Fragment, useState, useContext } from "react"
import i18n from "i18next"
import Dialog from "@material-ui/core/Dialog"
import DialogContent from "@material-ui/core/DialogContent"
import { LoadingContext } from "./context/LoadingContext"
import videoUrl from "../images/home/VideoExsis2023.mp4"
import videoUrlEnglish from "../images/home/ExsisCorporativosubtitulado.mp4"
import ReactPlayer from "react-player/lazy"
import { Link } from "gatsby"
import X from "../images/home/Xbanners.png"

const SharedBanner = ({
  bannerImageURL,
  scrollForm,
}) => {
  const [dinamicHeightColBanner, setDinamicHieghtColbanner] = useState(0)
  const { windowWidth } = useContext(LoadingContext)

  const [open, setOpen] = React.useState(false)

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <Fragment>
      {windowWidth > 1025 ? (
        <div className="shared-banner-containerMainHome">        
          <img className={windowWidth >1700 ? 'xBannerHome':'xBannerHomelaptp'} src={X} alt='x'></img>
        <div className="banner-layout horizontal-layout">



          <div className="banner-image" onClick={handleClickOpen}>
            <img src={bannerImageURL} alt="Imagen PopUp" className="imgBannerExperience contentVideoHome"/>
          </div>

        </div>
      </div>
      ):(
        <div className="shared-banner-containerMainHomeMobile">        
          <div className="banner-layout vertical-layout">
            <div className="banner-image mt-2" onClick={handleClickOpen}>
              <img src={bannerImageURL} alt="Imagen PopUp" className="imgBannerExperience "/>
            </div>
            
          </div>
        </div>
      )
      }

        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="form-dialog-title"
          maxWidth={false}
        >
          <DialogContent>
            <div>
              {i18n.language == "es" ?
                 <ReactPlayer
                 width="66rem"
                 height="100%"
                 className="VideoDiv"
                 playing={true}
                 controls={true}
                 url={videoUrlEnglish}
               />:
               <ReactPlayer
               width="66rem"
               height="100%"
               className="VideoDiv"
               playing={true}
               controls={true}
               url={videoUrl}
             />
              }
             
            </div>
          </DialogContent>
        </Dialog>
    </Fragment>
  )
}

SharedBanner.defaultProps = {
  flag: true,
  clase: "shared-banner-footer banner-text-white mt-8",
  style: {},
}

export default SharedBanner
